import { ILocation, TLocation } from '../../../types/location';

export interface IGeoSuggestContainerOwnProps {
  rightAddon?: React.ReactNode;
  redesign?: boolean;
  onHighwaySelected?(): void;
  onGeoSelected?(): void;
  onBSCenterSelected?(): void;
  onKPSelected?(id: number): void;
  onCoworkingSelected?(id: number): void;
}

export function getBoundedBy(currentLocation: TLocation, regions: ILocation[]) {
  let location: ILocation | undefined;

  if (currentLocation === 'moscow_mo') {
    const region = regions.filter(r => r.id === 4593).shift();

    if (region) {
      location = region;
    }
  } else if (currentLocation === 'spb_lo') {
    const region = regions.filter(r => r.id === 4588).shift();

    if (region) {
      location = region;
    }
  } else if (!currentLocation.boundedBy && currentLocation.parentId) {
    const region = regions.filter(r => r.id === currentLocation.parentId).shift();

    if (region) {
      location = region;
    }
  } else {
    location = currentLocation;
  }

  if (!location || !location.boundedBy) {
    return undefined;
  }

  return [
    [location.boundedBy.upperCorner.lng, location.boundedBy.upperCorner.lat],
    [location.boundedBy.lowerCorner.lng, location.boundedBy.lowerCorner.lat],
  ] as [YMaps.TCoord, YMaps.TCoord];
}
